import React, { useId } from 'react';
type Props = {
  variant?: 'light' | 'dark';
  title?: string;
};
const JOTFORM_SRC = 'https://form.jotform.com/261894703462059';
export function InquiryForm({
  variant = 'light',
  title = 'Connect with a Senior Living Specialist'
}: Props) {
  const isDark = variant === 'dark';
  const reactId = useId().replace(/[:]/g, '');
  const iframeId = `JotFormIFrame-${reactId}`;
  return <div className={`overflow-hidden rounded-md p-5 sm:p-6 ${isDark ? 'bg-forest-dark' : 'bg-white shadow-xl ring-1 ring-sand'}`} data-id="element-86" data-mp="3vtnpfjyip8za">
      <h3 className={`font-display text-2xl leading-snug sm:text-[27px] ${isDark ? 'text-white' : 'text-forest'}`} data-id="element-87" data-mp="4ncwkb3nvej1">
        {title}
      </h3>
      <div className="mt-2 h-0.5 w-14 bg-gold" data-id="element-88" data-mp="3r2xi416j6w1y" />

      <div className="mt-2 w-full overflow-hidden" data-id="element-89" data-mp="3r1mj0eo16ch6">
        {/*
          Fixed height + scrolling disabled and NO auto-resize embed handler.
          The JotForm embed handler continuously re-measures and re-sets the
          iframe height, which made the bottom of the form jitter. A stable
          fixed height sized to the (compacted) form removes the jitter.
           The gap between our heading and the form's first field is JotForm's
          own built-in top padding, which lives inside the iframe and can't be
          edited. A negative top margin pulls the iframe up so that built-in
          padding tucks under the heading, closing the visible gap. The parent
          uses overflow-hidden so nothing spills above.
         */}
        <iframe id={iframeId} title="Connect with a Senior Living Specialist" allow="geolocation; microphone; camera; fullscreen; payment" src={JOTFORM_SRC} frameBorder={0} scrolling="no" style={{
        display: 'block',
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        height: 670,
        marginTop: -20,
        border: 'none'
      }} data-id="element-90" data-mp="sx8p3kg8f7up" />
      </div>
    </div>;
}